<template>
  <div class="promoter-order" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">累计推广订单</div>
          <div>
            <span class="num">{{ count }}</span>单
          </div>
        </div>
        <div class="iconfont icon-2"></div>
      </div>
    </div>

    <div class="time_where">
      <div>
        <div class="time_item" style="width: 50%">
          <zm-datepicker
            type="week"
            v-model="where.startTime.time"
            @select-time="selectSDate"
            placeholder="选择日期"
          ></zm-datepicker>
          <!--<date-picker :date="where.startTime" :option="option"></date-picker>-->
        </div>
        <div class="time_item" style="padding-top: 18px;width: 35%">
          <span style="font-size: 13px">状态：</span>
          <select v-model="where.selected">
            <option>全部</option>
            <option>未支付</option>
            <option>已支付</option>
            <option>待收货</option>
            <option>待核销</option>
            <option>已收货</option>
            <option>交易完成</option>
            <option>退款中</option>
            <option>已退款</option>
            <option>退款</option>
          </select>
          <!--<date-picker :date="where.endtime"  :option="option1"></date-picker>-->
        </div>

        <div class="button" style="width: 15%" @click="chaxun">
          <span>查询</span>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <!--<div class="title acea-row row-column row-center">-->
        <!--<div class="data">{{ item.time }}</div>-->
        <!--<div>本月累计推广订单：{{ item.count ? item.count : 0 }}单</div>-->
        <!--</div>-->
        <div class="listn">
          <div class="itenm" v-for="(val, indexn) in item.child" :key="indexn">
            <div class="top acea-row row-between-wrapper">
              <div class="pictxt acea-row row-between-wrapper">
                <div class="pictrue">
                  <img :src="val.avatar" />
                </div>
                <div class="text line1">{{ val.nickname }}</div>
              </div>
              <div class="money">
                返佣：
                <span class="font-color-red">￥{{ val.number ? val.number : 0 }}</span>
              </div>
            </div>
            <div class="bottom">
              <div>
                <span class="name">购买项目：</span>
                {{ val.pname }}
              </div>
              <div>
                <span class="name">支付金额：</span>
                {{ val.pay_price }}
              </div>
              <div>
                <span class="name">订单状态：</span>
                {{ status(val.status) }}
              </div>
              <div>
                <span class="name">订单号：</span>
                {{ val.order_id }}
              </div>
              <div>
                <span class="name">下单时间：</span>
                {{ val.time }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
.time_where {
  background-color: #fff;
  height: 60px;
  border-bottom: #cecece solid 1px;
}
.time_item {
  width: 50%;
  float: left;
  padding-top: 15px;
}

.time_item .vue-datepicker {
  font-size: 13px;
  color: #777777;
}

.vue-datepicker .vue-datepicker-panels {
  width: 300px !important;
}

.vue-datepicker .vue-datepicker-panel .vue-datepicker-month span {
  width: 210px !important;
}

.time_item select {
  padding-top: 1px;
  font-size: 13px;
  color: #777777;
}

.week-input {
  left: 1px !important;
}

.button {
  float: left;
  width: 10%;
  font-size: 13px;
  color: #5f5f5f;
  padding-top: 19px;
}
.button span {
  background-color: #fb8561;
  padding: 5px 10px;
  color: #fff;
  border-radius: 100px;
}
</style>
<script>
import { getSpreadOrder } from "../../../api/user";
import Loading from "@components/Loading";
import myDatepicker from "vue-datepicker/vue-datepicker-es6.vue";
import zmDatepicker from "dm-vue-datepicker/datepicker/datepicker.vue";
export default {
  name: "PromoterOrder",
  components: {
    Loading,
    "date-picker": myDatepicker,
    "zm-datepicker": zmDatepicker
  },
  props: {},
  data: function() {
    return {
      list: [],
      where: {
        page: 1,
        limit: 15,
        startTime: {
          time: ""
        },
        endtime: {
          time: ""
        },
        selected: "全部"
      },
      loaded: false,
      loading: false,
      loadTitle: "",
      count: "",

      timeoption: {
        type: "min",
        week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
        month: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        format: "YYYY-MM-DD HH:mm"
      },
      multiOption: {
        type: "multi-day",
        week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
        month: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        format: "YYYY-MM-DD HH:mm"
      },
      limit: [
        {
          type: "weekday",
          available: [1, 2, 3, 4, 5, 6, 7]
        },
        {
          type: "fromto",
          from: "1970-01-01",
          to: "2019-12-31"
        }
      ]
    };
  },

  mounted: function() {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndex();
    });
  },

  methods: {
    status: function(status) {
      return status;
    },

    selectSDate: function(type, data) {
      console.log(type); //month-当前日历类型为选择月,day-当前日历类型为选择日,week-当前日历类型为选择周,hour-当前日历类型为选择小时,minute-当前日历类型为选择分钟内
      console.log(data); //不同类型的日历 返回的值不一样
    },

    async chaxun() {
      let there = this;
      there.loading = true;
      there.where.page = 1;
      there.list = [];
      getSpreadOrder(there.where).then(
        res => {
          there.loading = false;
          there.loaded = res.data.list.length < there.where.limit;
          there.loadTitle = there.loaded ? "人家是有底线的" : "上拉加载更多";
          there.where.page = there.where.page + 1;
          there.list.push.apply(there.list, res.data.list);
          there.count = res.data.count;
        },
        error => {
          there.$dialog.message(error.msg);
        },
        300
      );
    },
    getIndex: function() {
      let there = this;
      if (there.loaded == true || there.loading == true) return;
      there.loading = true;
      getSpreadOrder(there.where).then(
        res => {
          there.loading = false;
          there.loaded = res.data.list.length < there.where.limit;
          there.loadTitle = there.loaded ? "人家是有底线的" : "上拉加载更多";
          there.where.page = there.where.page + 1;
          there.list.push.apply(there.list, res.data.list);
          there.count = res.data.count;
          console.log(res.data);
        },
        error => {
          there.$dialog.message(error.msg);
        },
        300
      );
    }
  }
};
</script>
